export enum ACCR_REQUEST_STATUS {
  NEW = 'NEW',
  INVITED = 'INVITED',
  RECEIVED = 'RECEIVED',
  DATA_COMPLETED = 'DATA_COMPLETED',
  APPROVED = 'APPROVED',
  READY_TO_PRINT = 'READY_TO_PRINT',
  PRINTED = 'PRINTED',
  REJECTED = 'REJECTED',
  DELIVERED = 'DELIVERED',
}
